<template lang="pug">
  sui-segment(vertical)
    sui-grid(v-if="display === 'table'")
      sui-grid-row(:columns="2")
        sui-grid-column(
          v-for="team, i in teams",
          :key="team ? team.id : i")
          player-stats-table(
            :logo="team ? team.logo.main.svg : defaults.logo",
            :statTypes="statTypes",
            :stats="stats[i]")

    compare-table(
      v-if="display === 'compare'",
      :statTypes="statTypes",
      :teams="teams",
      :stats="stats")

    compare-chart(
      v-if="display === 'chart'",
      :statTypes="statTypes",
      :teams="teams",
      :stats="stats",
      :ratio="true")

    compare-chart(
      v-if="display === 'chart'",
      :statTypes="statTypes",
      :teams="teams",
      :stats="stats")
</template>

<script>
import CompareChart from '@/components/game/CompareChart.vue';
import CompareTable from '@/components/game/CompareTable.vue';
import PlayerStatsTable from '@/components/game/PlayerStatsTable.vue';

export default {
  name: 'PlayerStats',
  components: {
    CompareChart,
    CompareTable,
    PlayerStatsTable,
  },
  props: {
    games: {
      required: true,
    },
    teams: {
      required: true,
    },
    players: {
      required: true,
    },
    display: String,
  },
  data() {
    return {
      statTypesBase: [
        {
          name: 'FB',
          longName: 'Final Blows',
          key: 'finalBlows',
          maximize: true,
        },
        {
          name: 'E',
          longName: 'Eliminations',
          key: 'eliminations',
          maximize: true,
        },
        {
          name: 'D',
          longName: 'Deaths',
          key: 'deaths',
          maximize: false,
        },
        {
          name: 'A',
          longName: 'Assists',
          key: 'assists',
          sumOf: ['defensiveAssists', 'offensiveAssists'],
          maximize: true,
        },
        {
          name: 'Damage',
          longName: 'Hero Damage Done',
          key: 'heroDamageDone',
          maximize: true,
        },
        {
          name: 'Heal',
          longName: 'Healing Done',
          key: 'healingDone',
          maximize: true,
        },
      ],
      defaults: {
        name: '--',
        logo: '/logo-placeholder.svg',
      },
    };
  },
  computed: {
    initialStats() {
      return this.statTypesBase.reduce(
        (acc, stat) => ({
          ...acc,
          [stat.key]: 0,
        }),
        {},
      );
    },
    statTypes() {
      return this.statTypesBase.map(type => ({
        ...type,
        best: type.maximize
          ? Math.max(...this.singleStats.map(player => player.stats[type.key]))
          : Math.min(...this.singleStats.map(player => player.stats[type.key])),
        worst: type.maximize
          ? Math.min(...this.singleStats.map(player => player.stats[type.key]))
          : Math.max(...this.singleStats.map(player => player.stats[type.key])),
      }));
    },
    gamesStat() {
      return this.games.filter(x => x.stats);
    },
    stats() {
      if (!this.games.length || !this.players.length || !this.gamesStat.length) {
        return [[], []];
      }

      const teamPlayers = this.teams
        .map((team, i) => this.gamesStat.reduce((acc, game) => acc.concat(game.seenPlayers[i]), []))
        .map(players => players.filter((v, i, a) => a.indexOf(v) === i));

      return teamPlayers
        .map(players =>
          players.map(playerId => ({
            info: this.players.find(x => x.playerId === playerId),
            stats: this.gamesStat.reduce((acc, game) => {
              const playerStat = game.stats.find(x => x.playerId === playerId);

              if (playerStat) {
                return this.statTypesBase.reduce((statAcc, stat) => {
                  if (stat.sumOf) {
                    return {
                      ...statAcc,
                      [stat.key]: acc[stat.key] + stat.sumOf.reduce((a, v) => a + playerStat[v], 0),
                    };
                  }
                  return {
                    ...statAcc,
                    [stat.key]: acc[stat.key] + playerStat[stat.key],
                  };
                }, {});
              }

              return acc;
            }, this.initialStats),
          })),
        )
        .map(tp => tp.filter(p => this.noZeroPlayer(p)));
    },
    singleStats() {
      return this.stats.reduce((a, v) => a.concat(v), []);
    },
  },
  methods: {
    noZeroPlayer(player) {
      return (
        this.statTypesBase.reduce((a, stat) => a || player.stats[stat.key], false) && player.info
      );
    },
  },
};
</script>
